module.exports = __webpack_public_path__ + "static/media/screenshot_history_1_ru.561418ee.png";